<template>
  <div class="option-time">
    <div class="k-card">
      <div class="range-title">
        <div class="range-title-item pl-2 range-date text-weight-semi-bold">
          {{ formatedDate }} &nbsp;
        </div>

        <div
          @click="$emit('remove-date')"
          class="m-l-1 text-size-14 text-mid-grey text-weight-semi-bold pointer"
        >
          <font-awesome-icon :icon="['fal', 'trash-alt']" />
          {{ $t('options.removeDay') }}
        </div>
      </div>
      <div
        class="d-flex align-items-center text-size-14"
        v-for="(range, index) in dayOption.ranges"
        :key="index"
      >
        <time-range
          :date="dayOption.date"
          :range="dayOption.ranges[index]"
          @focus="onFocus"
          @blurr="onBlurr"
          @update="onUpdate"
          @updateRange="(range) => setRange(index, range)"
          @updateDuration="onUpdateDuration"
        ></time-range>
        <font-awesome-icon
          @click="removeRange(index)"
          class="fa mr-1 text-grey pointer"
          :icon="['fal', 'trash-alt']"
        />
      </div>
      <div class="option-time-footer">
        <div
          @click="$emit('add-range')"
          class="k-add-range text-left text-size-14 text-weight-semi-bold ml-2 pointer"
        >
          <font-awesome-icon :icon="['fal', 'plus-circle']" />
          {{ $t('options.addRange') }}
        </div>
        <div
          @click="$emit('copy-range')"
          class="k-add-range text-left text-size-14 text-weight-semi-bold ml-4 pointer"
        >
          <font-awesome-icon :icon="['fas', 'copy']" />
         {{ $t('options.copyRange') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LocalisedDate } from '@/components/mixins/LocalisedDate.js';
import TimeRange from '@/components/Create/TimeRange.vue';

export default {
  name: 'OptionTime',
  props: ['dayOption'],

  watch: {
    dayOptions: function (newVal, oldVal) {
      // watch it
      console.log('dayOption changed: ', newVal, ' | was: ', oldVal);
    },
  },

  data: function () {
    return {};
  },

  components: {
    TimeRange,
  },
  methods: {
    onFocus() {
      console.log('otptionTime - OnFocus');
      this.$emit('focus');      

    },

    onBlurr() {
      console.log('otptionTime - OnBlurr');
      this.$emit('blurr');      

    },    

    onUpdate(range) {
      console.error('range update:', range);
      this.$emit('update', range);
    },

    onUpdateDuration(duration) {
      this.defaultDuration = duration;
    },

    setRange(index, range) {

      let startDate = new Date(range.start);
      let endDate = new Date(range.end);
      if (startDate.getTime() > endDate.getTime()) {
        range.end = null;
      }
      //console.info('setRange:', startDate, endDate, range);
      //this.$set(this.dayOption.ranges, index, range);
      this.$emit('update', range);
      this.range = range;
    },

    removeRange(index) {
      this.$emit('remove-range', index);
    },
  },

  mixins: [LocalisedDate],

  computed: {
    formatedDate() {
      let d = this.localisedDate(this.dayOption.date.getTime());
      return d.month + ' ' + d.date + ' ' + d.day;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/colors';

.option-time {
  font-size: 0.8rem;
  background: white;
  border-radius: 4px;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 8px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}

.option-time-footer {
  display: flex;
}

.multiple {
  input {
    margin-top: 5px;
  }

  input:first-of-type {
    margin-top: 0px;
  }
}

.v-select {
  margin-top: 5px;
  background-color: white;
}

.range-title {
  display: flex;
  //justify-content: space-around;
  flex-basis: 30px;
  flex-grow: 1;
  padding-top: 8px;
}

.range-title-item {
  flex-basis: 20px;
  flex-grow: 1;
  text-align: left;
  cursor: pointer;
  color: $dark-grey;
}

button {
  font-size: 0.6rem;
  box-sizing: border-box;
  text-transform: uppercase;
  font-weight: 500;
  border: none;
  border-radius: 5px;
  padding: 0 16px;
  line-height: 32px;
  transition: all 0.2s;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.range-date {
  color: $dark-grey;
  font-size: 20px;
}

.k-add-range {
  padding-bottom: 10px;
}
</style>
